const $inject = ['$scope', '$routeParams', 'dataService', 'settingsService'];

const lbaKeyValuePairsCtrl = function ($scope, $routeParams, dataService, settingsService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);


  vm.addNew = addNew;
  vm.remove = remove;
  vm.getOptions = getOptions;
  vm.addSelected = addSelected;

  vm.keyOptions = settingsService.options[vm.settings.keyOptions];
  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  vm.sortableOptions = {
    disabled: false,
    stop: function (e, ui) {
      
    }
  };
  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function addNew() {
    if (!vm.data) {
      vm.data = [];
    }
    vm.data.push({Key: '', Value: ''});
  }
  
  function remove(index) {
    vm.data.splice(index, 1);
    vm.showRemove = [];
  }

  function getOptions(options, userInput) {
    const opts = angular.copy(options);
    if (userInput.length > 0) {
      opts.unshift(userInput);
    }
    return opts;
  }

  function addSelected(item) {
    if (vm.keyOptions.indexOf(item) === -1) {
      vm.keyOptions.unshift(item);
    }
  }

};

lbaKeyValuePairsCtrl.$inject = $inject;

export default lbaKeyValuePairsCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaKeyValuePair/lbaKeyValuePairsCtrl.js